import React, { useState } from "react";

const GovernanceGuidesBox = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleContent = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const boxes = [
    {
      title: "أدلة الحوكمة لعام 2023",
      content: [
        {
          columnTitleLeft: "محاضر الجمعية العمومية",
          columnTitleRight: "",
          left: [
            "محاضر الجمعية العمومية",
            "محاضر الجمعية العمومية غير العادية",
          ],
          right: [],
        },
        {
          columnTitleLeft: "",
          columnTitleRight: "",
          left: [],
          right: [],
        },
      ],
    },
    {
      title: "أدلة الحوكمة لعام 2022",
      content: [
        {
          columnTitleLeft: "اللوائح والنموذج الشامل",
          columnTitleRight: "التقارير والقوائم المالية",
          left: [
            "آلية إدارة المتطوعين",
            "آليه للتأكد من استحقاق المستفيد ",
            "اللائحة الأساسية",
            "الهيكل التنظيمي",
            "اّليه لإدارة طلبات العضوية فى الجمعية العمومية",
            "شهادة التسجيل للجمعية ",
            "لائحة بصلاحيات المجلس والصلاحيات التي فوّضها وإجراءات اتخاذ القرار ومدة التفويض",
            "نظام الرقابة الداخلى",
          ],
          right: [
            "التقرير السنوي المفصّل عن القوائم المالية والمعتمد من الجمعية العمومية",
            "تقرير المحاسب القانوني عن العام",
          ],
        },
        {
          columnTitleLeft: "السياسات",
          columnTitleRight: "التقارير العامة",
          left: [
            "سياسة الإبلاغ عن المخالفات وحماية مقدمي البلاغات",
            "سياسة الاحتفاظ بالوثائق واتلافها",
            "سياسة تعارض مصالح الجمعيات",
            "سياسة تنظيم العلاقة مع المستفيدين",
            "سياسة جمع التبرعات",
            "سياسة خصوصية البيانات",
            "قائمة السياسات والإجراءات عند الاشتباه في أن الأموال أو بعضها تمثل عمليات لها علاقة بغسل الأموال أو أنها سوف تستخدم في عمليات غسل أموال.",
            "قائمة المؤشرات الدالة على وجود شبهة غسيل أموال",
          ],
          right: [
            "تقارير أنشطة وبرامج تحديد وفهم مخاطر جرائم الإرهاب وتمويلة لديها وتقييمها وتوثيقها ",
            "تقييم المخاطر المتأصلة والكامنة",
            "قائمة السياسات و الإجراءات والضوابط المتعلقة بتدابير العناية الواجبة لمكافحة جرائم الإرهاب وتمويله",
            "قائمة مخاطر مطابقة مع عمل الجمعية ",
          ],
        },
        {
          columnTitleLeft: "محاضر الجمعية العمومية",
          columnTitleRight:
            "قوائم أعضاء مجلس الإدارة والجمعية العمومية واللجان والموظفين",
          left: [
            "محاضر الجمعية العمومية للعام الحالي",
            "محاضر الجمعية العمومية للعام الماضي",
          ],
          right: ["قائمة أعضاء الجمعية العمومية"],
        },
        {
          columnTitleLeft: "أخرى",
          columnTitleRight: "",
          left: [
            "قائمة الإجراءات المتبعة لتعريف أعضاء المجلس الجدد بعمل الجمعية",
          ],
          right: [],
        },
      ],
    },
    {
      title: "أدلة الحوكمة لعام 2021",
      content: [
        {
          columnTitleLeft: "الخطة الاستراتيجية والتشغيلية",
          columnTitleRight:
            "قوائم أعضاء مجلس الإدارة والجمعية العمومية واللجان والموظفين",
          left: ["الخطة التشغيلية"],
          right: ["قائمة أعضاء الجمعية العمومية"],
        },
        {
          columnTitleLeft: "محاضر الجمعية العمومية",
          columnTitleRight: "",
          left: ["محضر الجمعية العمومية للعام الحالي"],
          right: [],
        },
      ],
    },
    {
      title: "أدلة الحوكمة لعام 2020",
      content: [
        {
          columnTitleLeft: "التقارير والقوائم المالية",
          columnTitleRight: "",
          left: ["تقرير المحاسب القانوني عن العام"],
          right: [],
        },
        {
          columnTitleLeft: "",
          columnTitleRight: "",
          left: [],
          right: [],
        },
      ],
    },
    {
      title: "أدلة الحوكمة لعام 2019",
      content: [
        {
          columnTitleLeft: "التقارير والقوائم المالية",
          columnTitleRight: "",
          left: ["تقرير المحاسب القانوني عن العام"],
          right: [],
        },
        {
          columnTitleLeft: "",
          columnTitleRight: "",
          left: [],
          right: [],
        },
      ],
    },
  ];

  return (
    <>
      <div className="space-y-4, mt-4 md:text-sm text-base">
        {boxes.map((box, index) => (
          <div key={index} className="border rounded shadow-md">
            <div
              className="cursor-pointer p-3 bg-gray-200 rounded-t hover:bg-gray-300"
              onClick={() => toggleContent(index)}
            >
              {box.title}
            </div>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                openIndex === index
                  ? "height-auto opacity-100"
                  : "max-h-0 opacity-0"
              }`}
              style={{
                height: openIndex === index ? "auto" : "0",
              }}
            >
              <div className="p-3 bg-gray-100 rounded-b">
                {box.content.map((row, rowIndex) => (
                  <div key={rowIndex} className="grid grid-cols-2 gap-4 mb-4">
                    {/* Left Column with Title and List in a Box */}
                    <div className="border p-4 rounded min-h-[100px]">
                      <h3 className="font-semibold mb-2">
                        {row.columnTitleLeft}
                      </h3>
                      <ul className="list-disc pl-5">
                        {row.left.map((item, itemIndex) => (
                          <li className="mt-4" key={itemIndex}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                    {/* Right Column with Title and List in a Box */}
                    <div className="border p-4 rounded min-h-[100px]">
                      <h3 className="font-semibold mb-2">
                        {row.columnTitleRight}
                      </h3>
                      <ul className="list-disc pl-5">
                        {row.right.map((item, itemIndex) => (
                          <li className="mt-4" key={itemIndex}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default GovernanceGuidesBox;
